// #region Imports

import { ApiServiceBase } from './apiServiceBase';

// #endregion Imports

export class BadgificationService extends ApiServiceBase {
    private apiUrl = '/api/badgification/1.0/';

    getAllBadgesForUser(onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(this.apiUrl + "getallbadgesforuser", onSuccess, onFailure);
    }

    addBadge(actionType: number, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(`${this.apiUrl}addbadge/${actionType}`, onSuccess, onFailure);
    }

    getWelcomeIntroText(onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(this.apiUrl + "getwelcomeintrotext", onSuccess, onFailure);
    }

    getOverviewText(onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(this.apiUrl + "getoverviewtext", onSuccess, onFailure);
    }

    getAssignmentData(actionType: number, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(`${this.apiUrl}getassignmentdata/${actionType}`, onSuccess, onFailure);
    }
}